(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-cpx-root]';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initGallery(root) {
    const tabs = Array.from(root.querySelectorAll('[data-cpx-thumb]'));
    const panels = Array.from(root.querySelectorAll('[data-cpx-panel]'));
    const current = root.querySelector('[data-cpx-current]');
    const caption = root.querySelector('[data-cpx-caption-output]');

    if (!tabs.length || !panels.length) return;

    const activate = (index, focus = false) => {
      const nextIndex = Math.max(0, Math.min(index, tabs.length - 1));

      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === nextIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus({ preventScroll: true });
      });

      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === nextIndex;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      const activePanel = panels[nextIndex];
      if (current) current.textContent = pad(nextIndex + 1);
      if (caption && activePanel) {
        caption.textContent = activePanel.dataset.cpxCaption || '';
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== index) {
          event.preventDefault();
          activate(nextIndex, true);
        }
      });
    });

    activate(Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active'))));
  }

  function initVariant(root) {
    const select = root.querySelector('[data-cpx-variant-select]');
    const price = root.querySelector('[data-cpx-price]');
    const compare = root.querySelector('[data-cpx-compare]');
    const availability = root.querySelector('[data-cpx-availability]');
    const availabilityValue = root.querySelector('[data-cpx-availability-value]');
    const submit = root.querySelector('[data-cpx-submit]');
    const submitLabel = root.querySelector('[data-cpx-submit-label]');

    if (!select) return;

    const update = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;

      const available = option.dataset.available === 'true';
      const availableLabel = availability?.dataset.labelAvailable || 'Verfügbar';
      const unavailableLabel = availability?.dataset.labelUnavailable || 'Nicht verfügbar';
      const buyLabel = submit?.dataset.labelAvailable || 'Digitale Ausgabe erwerben';
      const soldoutLabel = submit?.dataset.labelUnavailable || 'Nicht verfügbar';

      if (price && option.dataset.price) price.textContent = option.dataset.price;

      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }

      if (availability) availability.classList.toggle('is-available', available);
      if (availabilityValue) availabilityValue.textContent = available ? availableLabel : unavailableLabel;

      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? buyLabel : soldoutLabel;
    };

    select.addEventListener('change', update);
    update();
  }

  function initRoot(root) {
    if (!root || root.dataset.cpxReady === 'true') return;
    root.dataset.cpxReady = 'true';
    initGallery(root);
    initVariant(root);
  }

  function init(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) initRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
